export default __webpack_public_path__ + "static/media/coin.cae0d64b.png";